export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOG04.0db4f4b5.mp3";